import { Flex, FlexProps, Tag, Typography } from 'antd';
import * as Styles from './styles'
import { CalendarOutlined } from '@ant-design/icons';

export type Notifications = {
    notification_id: string;
    notification_date: string;
    notification_total: string;
    notification_message: string;
    notification_category: string;
    color: string;
};


type Props = {
    data: Notifications;
} & Omit<FlexProps, 'children'>;

export const NotificationsItem = ({ data, ...others }: Props) => {
    const {
        notification_date,
        notification_category,
        notification_total,
        notification_message,
        color,
    } = data;

    const getInitials = (description: string) => {
        if (description.length <= 1) {
            return description
        } else {
            return `${description.slice(0, 2)}`
        }
    }

    return (
        <Flex gap="small" {...others}>
            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                <Styles.AvatarContainer >
                    {getInitials(notification_message)}
                </Styles.AvatarContainer>
            </div>
            <Flex vertical gap="small" style={{ flexGrow: 1 }}>
                <Flex align="center" justify="space-between" >
                    <Typography.Text>
                        <b>{notification_message}</b>
                    </Typography.Text>
                    <Tag
                        bordered={true}
                        icon={<CalendarOutlined />}
                        style={{ textTransform: 'capitalize' }}
                    >
                        {notification_date}
                    </Tag>
                </Flex>
                <Flex justify="space-between" align="center">
                    <Tag bordered={true} color={color}>
                        {notification_category}
                    </Tag>
                    <Typography.Text style={{ marginRight: 8, }}><b>{notification_total}</b></Typography.Text>
                </Flex>
            </Flex>
        </Flex>
    );
};
